import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import React, { FC, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import useStyles from "./styles";

interface IUnlockCodesHeaderProps {
  couponCode: string;
  unlockCodesCount?: number;
  onBackClick?: () => void;
}

const UnlockCodesHeader: FC<IUnlockCodesHeaderProps> = ({
  couponCode,
  unlockCodesCount,
  onBackClick
}) => {
  const navigate = useNavigate();

  const handleBackClick = useCallback(() => {
    if (onBackClick !== undefined) {
      onBackClick();
    } else {
      navigate(-1);
    }
  }, [navigate, onBackClick]);

  const classes = useStyles({});
  return (
    <div className={classes.container}>
      <div className={classes.codeTextContainer}>
        <ArrowBackIcon
          id="unlockCodeHeaderBackIcon"
          className={classes.backArrow}
          onClick={handleBackClick}
        />
        <span className={classes.codeText}>
          Set Codes {!!couponCode ? `for ${couponCode}` : ""}
        </span>
      </div>
      <div className={classes.generatedFieldsText}>
        {unlockCodesCount !== undefined
          ? `Generated fields: (${unlockCodesCount}/${unlockCodesCount})`
          : ""}
      </div>
    </div>
  );
};

export default UnlockCodesHeader;
